import axios from "axios";

import getEnv from "@/config/env";
import { deleteCurrentUser, getCurrentUser } from "@/helpers/helper";
import store from "@/store";
import router from "@/router";
import { REFRESHTOKEN } from "@/store/_actiontypes";
import { getDepartmentPhones } from "@/helpers/Department_Phone";
import CryptoJS from "crypto-js";

let isRefreshingToken = false;
let callbacks = [];
let PersonalizerApi = axios.create({
  withCredentials: false,
  baseURL: getEnv("VUE_APP_PERSONALIZER_API"),
});

PersonalizerApi.interceptors.request.use(
  async (request) => {
    const user = getCurrentUser();

    request.headers["X-Client-Id"] = getEnv("VUE_APP_CLIENT_ID");
    request.headers["X-Client-Secret"] = getEnv("VUE_APP_CLIENT_SECRET");

    const activeProjectId = store.getters["project/activeProjectId"];
    request.headers["Project-Id"] = activeProjectId;

    if (user && user.access_token) {
      request.headers["Authorization"] = `Bearer ${user.access_token}`;
    }

    const userTags = store.state.account.userTags || [];
    const additionalTags = userTags
      .map(tag => String(tag || '').trim().toUpperCase())
      .filter(Boolean)
      .flatMap(tag => getDepartmentPhones(tag))
      .filter(Boolean); // optional: removes null/undefined/empty values
    if (additionalTags.length && activeProjectId) {
      const encryptedTags = CryptoJS.AES.encrypt(additionalTags.join(","), activeProjectId.toString()).toString();
      request.headers["X-Access-Tags"] = encryptedTags;
    }

    request.headers["Accept-Language"] = "en-gb";
    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

PersonalizerApi.interceptors.response.use(
  async (response) => {
    return response;
  },
  async (error) => {
    if (error.response && error.response.status === 401) {
      let user = getCurrentUser();

      if (user && user.refresh_token) {
        const originalRequest = error.config;

        if (!originalRequest.sent) {
          originalRequest.sent = true;

          if (!isRefreshingToken) {
            isRefreshingToken = true;

            return store
              .dispatch(
                `account/${REFRESHTOKEN}`,
                { refresh_token: user.refresh_token },
                { root: true }
              )
              .then(() => {
                isRefreshingToken = false;
                tokenRefreshed();
                originalRequest.headers.Authorization = `Bearer ${store.state.account.user.access_token}`;
                return PersonalizerApi(originalRequest);
              })
              .catch(() => {
                deleteCurrentUser();
                router.push("/login");
                return Promise.reject(error);
              });
          }
          // Always add to retry queue except the first request.
          return new Promise((resolve) => {
            addCallback(() => {
              originalRequest.headers.Authorization = `Bearer ${store.state.account.user.access_token}`;
              resolve(PersonalizerApi(originalRequest));
            });
          });
        }
      }
    }
    return Promise.reject(error);
  }
);

let tokenRefreshed = () => {
  const pending = [...callbacks];
  callbacks = [];
  pending.forEach((cb) => cb());
};

let addCallback = (callback) => {
  callbacks.push(callback);
};

export default PersonalizerApi;
